import React, { useEffect } from "react";
import ErrorLabel from "../../../../../component/error_label";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { actionUpdateClient, resetClientUpdateResponse } from "../store";
import $ from "jquery";
import toast from "react-hot-toast";
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../../../../common/app_constant";
const EmailLeadForm = () => {
    const { register, formState: { errors }, handleSubmit, control, reset } = useForm();

    const navigation = useNavigate()
    const dispatch = useDispatch()

    const { clientUpdate } = useSelector((state) => ({
        ...state.clientUpdateStore
    }))

    useEffect(() => {
        if (clientUpdate !== null) {
            dispatch(resetClientUpdateResponse())
            if (clientUpdate.result === true) {
                $("#update_client-loader").addClass("d-none");
                $("#update_client").prop("disabled", false);
                reset()
                toast.success(clientUpdate.message, {
                    duration: TOAST_DURATION,
                    position: TOAST_POSITION,
                    style: {
                        color: TOAST_SUCCESS_COLOR
                    }
                })
            } else {
                $("#update_client-loader").addClass("d-none");
                $("#update_client").prop("disabled", false);
                switch (clientUpdate.status_code) {
                    case 400:
                        toast.error(clientUpdate.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    case 401:
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [clientUpdate])

    const onSubmit = async (data) => {

        $("#update_client-loader").removeClass("d-none");
        $("#update_client").prop("disabled", true);
        dispatch(actionUpdateClient({
            client_id: '24195',
            name: data.name,
            email: data.email,
            address: data.address,
            contact_name: data.contact_name,
            contact_designation: data.contact_designation,
            contact_phone: data.contact_phone,
            contact_email: data.contact_email
        }))
    }

    return (
        <>
            <div className="row py-5">
                <div className="col-12">
                    <nav
                        className="--bs-breadcrumb-divider"
                        aria-label="breadcrumb"
                    >
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item active" aria-current="page">
                                Corporate Verification Form
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 col-md-8">
                    <div className="row">
                        <div className="col-12">
                            <div className="card profile-section">
                                <div className="card-body">
                                    <form
                                        noValidate
                                        autoComplete="off"
                                        onSubmit={handleSubmit(
                                            onSubmit
                                        )}>
                                        <div className="row">
                                            <div className="col-md-6 mt-3">
                                                <label className="form-label">
                                                    Customer Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="name"
                                                    {...register(
                                                        "name",
                                                        {
                                                            required: "This is required.",
                                                        }
                                                    )}
                                                />
                                                {errors.name && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .name
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <label className="form-label">
                                                    Customer Address
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="address"
                                                    {...register(
                                                        "address",
                                                        {
                                                            required: "This is required.",
                                                        }
                                                    )}
                                                />
                                                {errors.address && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .address
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <label className="form-label">
                                                    Primary Contact Person Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="contact_name"
                                                    {...register(
                                                        "contact_name",
                                                        {
                                                            required: "This is required.",
                                                        }
                                                    )}
                                                />
                                                {errors.contact_name && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .contact_name
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <label className="form-label">
                                                    Primary Contact Person Designation
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="contact_designation"
                                                    {...register(
                                                        "contact_designation",
                                                        {
                                                            required: "This is required.",
                                                        }
                                                    )}
                                                />
                                                {errors.contact_designation && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .contact_designation
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <label className="form-label">
                                                    Primary Contact Person Mobile
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="contact_phone"
                                                    {...register(
                                                        "contact_phone",
                                                        {
                                                            required: "This is required.",
                                                        }
                                                    )}
                                                />
                                                {errors.contact_phone && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .contact_phone
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <label className="form-label">
                                                    Primary Contact Person Email ID
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="contact_email"
                                                    {...register(
                                                        "contact_email",
                                                        {
                                                            required: "This is required.",
                                                        }
                                                    )}
                                                />
                                                {errors.contact_email && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .contact_email
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div className="col-12 mt-3">
                                                <button
                                                    id="update_client"
                                                    className="btn btn-primary"
                                                >Submit
                                                    <span id="update_client-loader" className="spinner-border spinner-border-sm ms-1 d-none"></span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default EmailLeadForm